export const wced_annual_report = [
  {
    id: 1,
    name: 'wced-app-2025-2026',
    summary: 'shortsummary/wced-app-2025-2026.html',
    link: 'wced-app-2025-2026.pdf',
    audio_en: 'audio/en/wced-app-2025-2026_en.mp3',
    audio_af: 'audio/af/wced-app-2025-2026_af.mp3',
    audio_xh: 'audio/xh/wced-app-2025-2026_xh.mp3'
  },
  {
    id: 2,
    name: 'wced-strategic-plan-2025-2030',
    summary: 'shortsummary/wced-strategic-plan-2025-2030.html',
    link: 'wced-strategic-plan-2025-2030.pdf',
    audio_en: 'audio/en/wced-strategic-plan-2025-2030_en.mp3',
    audio_af: 'audio/af/wced-strategic-plan-2025-2030_af.mp3',
    audio_xh: 'audio/xh/wced-strategic-plan-2025-2030_xh.mp3'
  }
];